import { render, staticRenderFns } from "./UserProfileInput.vue?vue&type=template&id=bb3308f4&scoped=true"
import script from "./UserProfileInput.vue?vue&type=script&lang=js"
export * from "./UserProfileInput.vue?vue&type=script&lang=js"
import style0 from "./UserProfileInput.vue?vue&type=style&index=0&id=bb3308f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb3308f4",
  null
  
)

export default component.exports
import QSelect from 'quasar/src/components/select/QSelect.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QList from 'quasar/src/components/item/QList.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QSelect,QItem,QList,QItemSection,QSeparator});
